module.exports = __webpack_public_path__ + "static/img/step2_sc@2x.67244bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/howtobuy/step2_sc@2x.jpg
// module id = 534
// module chunks = 0